import React, { Component } from 'react'
import { message } from 'antd'
import { get, omit, pick } from 'lodash'
import Members from '../../../../../api/Members'
import ContractsApi from '../../../../../api/People/LabourContracts'
import Employees from '../../../../../api/Employees'
import { execute } from '../../../../../modules/Utils'
import DocumentsApi from '../../../../../api/Documents'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import ViewContract from '../../../../../components/People/Member/Contract/ViewContract/ViewContract'

class ViewContractCont extends Component {
  constructor (props) {
    super(props)
    let contract = get(props.location, 'state.contract') || {}
    let entitlements = contract.entitlements || {}
    contract = omit(get(props.location, 'state.contract') || {}, 'entitlements')
    this.state = {
      created: false,
      id: props.match.params.key,
      contractKey: get(props.match, 'params.contractKey'),
      submitting: false,
      fetching: false,
      employeeFetching: false,
      linesList: [],
      actions: [],
      member: get(props.location, 'state.member') || {},
      employee: get(props.location, 'state.employee') || {},
      contract: Object.assign({}, contract, {
        annual: entitlements.annual || [],
        compassionate: entitlements.compassionate || [],
        hospitalisation: entitlements.hospitalisation || [],
        medical: entitlements.medical || [],
        parental: entitlements.parental || [],
        rollover: entitlements.rollover || {},
        medicalOptions: entitlements.medicalOptions || { reimbursable: false },
      }),
      updatingState: false,
    }
    this.contractApi = new ContractsApi()
    this.api = new Employees()
    this.memberApi = new Members()
    this.docsApi = new DocumentsApi()
  }

  overviewCmpRef = React.createRef()
  keyTermsCmpRef = React.createRef()
  payrollCmpRef = React.createRef()
  communicationCmpRef = React.createRef()

  async componentDidMount () {
    await this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const employeeResponse = await this.api.getMember(this.state.id)
      const memberResponse = await this.memberApi.get(this.state.id)
      let contract = await this.contractApi.get(this.state.contractKey)
      const actions = await this.docsApi.actions(
        'labourContracts',
        contract.status,
      )
      let entitlements = contract.entitlements || {}
      contract = omit(contract || {}, 'entitlements')
      contract = Object.assign({}, contract, {
        annual: entitlements.annual || [],
        compassionate: entitlements.compassionate || [],
        hospitalisation: entitlements.hospitalisation || [],
        medical: entitlements.medical || [],
        parental: entitlements.parental || [],
        rollover: entitlements.rollover || {},
        medicalOptions: entitlements.medicalOptions || {
          reimbursable: false,
        },
      })
      let member = await memberResponse.json()
      let employee = await employeeResponse.json()
      this.setState({
        member,
        employee,
        contract,
        actions,
        fetching: false,
        employeeFetching: false,
      })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        fetching: false,
        employeeFetching: false,
      })
    }
  }
  handleOps = async (operation, contract) => {
    const {
      submit,
      revise,
      cancel,
      remove,
      reject,
      approve,
      close,
    } = this.contractApi
    const { employee, member } = this.state
    const { history } = this.props
    switch (operation) {
      case 'default':
        await execute(
          this,
          this.contractApi.default.set.bind(
            this,
            pick(contract, ['_key', '_rev', '_id']),
          ),
          message,
        )
        await this.fetch()
        break
      case 'revise':
        await execute(
          this,
          revise.bind(this, pick(contract, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
      case 'update':
        history.push({
          pathname: `update`,
          state: { contract, employee, member },
        })
        break

      case 'submit':
        await execute(
          this,
          submit.bind(this, pick(contract, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
      case 'approve':
        await execute(
          this,
          approve.bind(this, pick(contract, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
      case 'cancel':
        await execute(
          this,
          cancel.bind(this, pick(contract, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
      case 'remove':
        await execute(
          this,
          remove.bind(this, pick(contract, ['_key', '_rev', '_id'])),
          message,
        )
        history.replace({
          pathname: `people/member/${member._key}/`,
          state: { contract, employee, member },
        })
        break

      case 'reject':
        await execute(
          this,
          reject.bind(this, pick(contract, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
      case 'close':
        await execute(
          this,
          close.bind(this, pick(contract, ['_key', '_rev', '_id'])),
          message,
        )
        await this.fetch()
        break
    }
  }
  updateContractState = async state => {
    try {
      this.setState({
        updatingState: true,
      })
      const contract = await this.contractApi.updateState({
        ...pick(this.state.contract, ['_id', '_key', '_rev']),
        state,
      })
      this.setState({
        updatingState: false,
        contract,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        updatingState: false,
      })
    }
  }

  render () {
    return (
      <ViewContract
        {...this.state}
        {...pick(this, [
          'fetch',
          'handleOps',
          'updateContractState',
          'overviewCmpRef',
          'keyTermsCmpRef',
          'payrollCmpRef',
          'communicationCmpRef',
        ])}
      />
    )
  }
}

export default compose(withRouter)(ViewContractCont)
